const AUTH = {
  TOKEN: 'TOKEN',
};

export default AUTH;
